import { render, staticRenderFns } from "./ListInterestedScl.vue?vue&type=template&id=0470c414&"
import script from "./ListInterestedScl.vue?vue&type=script&lang=js&"
export * from "./ListInterestedScl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports